import heic2any from "heic2any";

export const parseFile = async (file: File) => {
  const isHeic = file.name?.toLowerCase().endsWith('.heic');
  if (!isHeic) return file;
  try {
    const convertedBlob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.9
    });
    if (Array.isArray(convertedBlob)) return convertedBlob[0];
    return convertedBlob;
  } catch (err) {
    console.error('HEIC conversion failed:', err);
    return file;
  }
};